import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Decorator from "ui/common/channel/messages/message/Decorator";

class Intro extends React.Component {

	constructor(props) {
		super(props);

		this.handleAvatarError = this.handleAvatarError.bind(this);
	}

	handleAvatarError(e) {
		e.target.src = this.props.configuration.baseDir + '/gfx/icons/user.png';
	}

	render() {
		if (!this.props.channel.intro) {
			return null;
		}

		return <div className="wcChannelIntro">
			<div className="wcChannelIntroAvatar">{this.props.channel.avatar && <img src={ this.props.channel.avatar } onError={ this.handleAvatarError } className="wcFunctional wcAvatar" alt={this.props.channel.name} /> }</div>
			<div className="wcChannelIntroContent">
				<Decorator>{ this.props.channel.intro }</Decorator>
			</div>
		</div>
	}

}

Intro.propTypes = {
	channel: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration
	})
)(Intro);